// src/components/ActionButton.tsx
import type { ReactElement, ReactNode } from 'react';

// Small action button with a pending/disabled state and label swap. Mirrors the
// AdminUserPage delete-button pattern (disabled while a mutation isPending).
// Used by the job/run action surfaces (A1EE-338).
const BASE =
  'rounded border px-3 py-1.5 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60';

const VARIANTS: Record<'primary' | 'danger' | 'neutral', string> = {
  primary: 'border-sky-600 bg-sky-600 text-white hover:bg-sky-700',
  danger: 'border-red-300 bg-white text-red-800 hover:border-red-400',
  neutral: 'border-slate-300 bg-white text-slate-700 hover:border-slate-400',
};

export function ActionButton({
  onClick,
  children,
  pending = false,
  pendingLabel = 'Working…',
  disabled = false,
  variant = 'neutral',
  type = 'button',
}: {
  onClick: () => void;
  children: ReactNode;
  pending?: boolean;
  pendingLabel?: string;
  disabled?: boolean;
  variant?: 'primary' | 'danger' | 'neutral';
  type?: 'button' | 'submit';
}): ReactElement {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || pending}
      className={`${BASE} ${VARIANTS[variant]}`}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
